import QuotesCarousel from "components/organisms/common/QuotesCarousel"
import useTranslations from "hooks/useTranslations"

import client1 from "images/influencers/clients/client-1.jpg"
import client2 from "images/influencers/clients/client-2.jpg"
import client3 from "images/influencers/clients/client-3.jpg"
import client4 from "images/influencers/clients/client-4.jpg"
import client5 from "images/influencers/clients/client-5.jpg"
import client7 from "images/influencers/clients/client-7.jpg"

export default function QuotesCarouselPro({ bgColor }) {
  const {
    hrCaseQuoteTitle,
    hrCaseQuote1Title,
    hrCaseQuote1Text,
    hrCaseQuote2Title,
    hrCaseQuote2Text,
    hrCaseQuote3Title,
    hrCaseQuote3Text,
  } = useTranslations()
  const slidesData = [
    {
      title: hrCaseQuote1Title,
      text: hrCaseQuote1Text,
      inboundLink: false,
      picture: client3,
    },
    {
      title: hrCaseQuote2Title,
      text: hrCaseQuote2Text,
      inboundLink: false,
      picture: client4,
    },
    {
      title: hrCaseQuote3Title,
      text: hrCaseQuote3Text,
      inboundLink: false,
      picture: client7,
    },
  ]

  return (
    <QuotesCarousel
      title={hrCaseQuoteTitle}
      slides={slidesData}
      bgColor={bgColor}
    />
  )
}
